var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:[_vm.tdClass, {'state-disabled': _vm.disabled}],attrs:{"colspan":_vm.colspan,"rowspan":_vm.rowspan}},[(!_vm.hasSlot)?_c(_vm.componentName,_vm._b({tag:"component",attrs:{"model":_vm.model,"readonly":_vm.disabled,"disabled":_vm.disabled,"title":_vm.title}},'component',_vm.fieldProps,false)):_vm._t("default"),_vm._t("afterField")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }